// extracted by mini-css-extract-plugin
export default {"main":"PurchaseOrders_main__YRS3F","paginationGroup":"PurchaseOrders_paginationGroup__Up3Qb","pagincationIcon":"PurchaseOrders_pagincationIcon__OCYm7"};